import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./Category.css"
import { useEffect, useState } from "react";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import BlockCategoryModal from "./BlockCategoryModal/BlockCategoryModal";
import useCategories from "../../hook/category/useCategories";
import { getTransformByBlocks, getWidth, getHeight } from "../../hook/category/categoryModel";
import hasPermission from "/src/utils/hasPermission";
function Category({ informations }) {

    const [hover, setHover] = useState(false)

    const { lockCategory, deleteCategory, updateCategory } = useCategories();
    const [infoCategory, setInfoCategory] = useState(informations)
    const [hoverLock, setHoverLock] = useState(false)

    const getBlocksCategory = () => {
        return infoCategory.category.categories_blocks.map(block => block.blocks)
    }
    const getTransformStyle = () => {
        let blocks = getBlocksCategory();
        if (blocks.length === 0) {
            console.log("infoCategory", infoCategory);
            return "0px,0px,0px";
        }
        let transform = getTransformByBlocks(blocks)
        return transform.x + "px," + transform.y + "px," + 0 + "px"
    }

    const getHeightCategory = () => {
        let blocks = getBlocksCategory();
        return getHeight(blocks)

    }
    const getWidthCategory = () => {
        let blocks = getBlocksCategory();
        return getWidth(blocks)
    }


    const onClickDeleteCategory = async () => {
        deleteCategory(infoCategory.category.id);
    }

    const showEditCategory = () => NiceModal.show(BlockCategoryModal, {
        category: infoCategory.category,
    }).then((data) => updateCategory(infoCategory.category.id, data));

    const onClickLockCategory = async () => {
        lockCategory(infoCategory.category.id, !infoCategory.category.locked);
    }

    const hexToRGB = (hex) => { //https://stackoverflow.com/questions/21646738/convert-hex-to-rgba
        var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);
        return "rgba(" + r + ", " + g + ", " + b + ", " + 0.2 + ")";
    }
    useEffect(() => {
        setInfoCategory(informations);
    }, [informations])

    return (
        <>
            {

                infoCategory &&

                <div id={infoCategory.category.object_id} className={"category_container " + (hover ? "category_hovered" : "")} style={{
                    transform: "translate3d(" + getTransformStyle() + ")",
                    width: getWidthCategory() != 0 ? getWidthCategory() + "px" : "200px", height: getHeightCategory() != 0 ? getHeightCategory() + "px" : "",
                    backgroundColor: hexToRGB(infoCategory.category.color), borderColor: infoCategory.category.color,
                    color: infoCategory.category.color
                }}
                    onMouseEnter={() => hasPermission('lock_bot_category') ? setHover(true) : setHover(false)} onMouseLeave={() => { setHover(false) }}>
                    <div className="category_settings">
                        <div className="category_title" style={{ color: infoCategory.category.color }} title={infoCategory.category.categories_notes[0].description}>
                            {
                                infoCategory.category.categories_notes[0].description != "" &&
                                <i className="fas fa-info-circle" title={infoCategory.category.categories_notes[0].description} style={{ marginRight: "10px" }}></i>

                            }
                            {infoCategory.category.name}
                        </div>
                        {hasPermission('lock_bot_category') ?
                            <div className="category_options" style={{ opacity: hover ? 1 : 0 }}>
                                <IconButton className="main-iconButton edit-hover modalButtons-input category_button_option category_button_lock" style={{ color: infoCategory.category.color }}
                                    icon={infoCategory.category.locked ? (hoverLock == false ? "fas fa-lock" : "fas fa-lock-open") : (hoverLock == false ? "fas fa-lock-open" : "fas fa-lock")}
                                    onClick={onClickLockCategory}
                                    onMouseEnter={() => setHoverLock(true)} onMouseLeave={() => setHoverLock(false)} />

                                <IconButton className={"main-iconButton remove-hover modalButtons-input category_button_option category_button_remove " + (infoCategory.category.locked && "category_button_locked")}
                                    style={{ color: infoCategory.category.color }} icon="fas fa-trash" onClick={onClickDeleteCategory} disabled={infoCategory.category.locked} />

                                <IconButton className={"main-iconButton edit-hover modalButtons-input category_button_option category_button_edit " + (infoCategory.category.locked && "category_button_locked")}
                                    style={{ color: infoCategory.category.color }} icon="fas fa-cog" onClick={showEditCategory} disabled={infoCategory.category.locked} />

                            </div> : null
                        }
                    </div>
                </div>

            }
        </>

    )
}

export default Category;